/**
 * Text block dimension constraints
 */
export const TEXT_BLOCK_CONSTRAINTS = {
  /** Minimum width of a text block in canvas units */
  MIN_WIDTH: 100,
  /** Minimum height of a text block in canvas units */
  MIN_HEIGHT: 30,
  /** Maximum character count for text content */
  MAX_CHARS: 500,
  /** Default width for new blocks in canvas units */
  DEFAULT_WIDTH: 150,
  /** Padding added when measuring text width in canvas units */
  MEASURE_PADDING: 30,
  /** Minimum width for auto-measured blocks */
  MIN_AUTO_WIDTH: 50,
} as const;
